export const TAB = {
  'tabs' : [{id: 'overview', isActive: 'true', description: ''},
            {id: 'details', isActive: 'false', description: ''},
            {id: 'pricing', isActive: 'false', description: ''}]
};
